export default "__VITE_ASSET__CmoQUcLn__"